import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { UserAvatar } from "./user-avatar.js";
import { TextRevealer } from "./text-revealer.js";
import { IsDateInPast, IsoDateFormatter } from "../lib/date-utilities.js";

UserAvatar.Register();
TextRevealer.Register();

/**
* Get the proper edit / message buttons for a date, depending on admin status etc
* Used both for meal-date-row, and the mobile detail of calendar-display
* @param trainDate an nMealTrainDate
* */
function GetActionButtons(trainDate) {
    return html`
        <a class="button button-rectangle button-outline message-button" href="/trains/${window.CurrentTrain.Id}/message/${trainDate.AssignedUser.Id}">
            <svg role="img" width="24" height="24" aria-label="Message"><use xlink:href="#envelope-blue" /></svg><span class="text">Message</span>
        </a>
        <a class="button button-rectangle button-blue edit-own-button" href="/trains/${window.CurrentTrain.Id}/volunteer/${trainDate.Id}">
            <svg role="img" width="24" height="24" aria-label="Edit"><use xlink:href="#edit-white" /></svg><span class="text">Edit</span>
        </a>
        <a class="button button-rectangle button-outline edit-button" href="/trains/${window.CurrentTrain.Id}/volunteer/${trainDate.Id}">
            <svg role="img" width="24" height="24" aria-label="Edit"><use xlink:href="#edit-blue" /></svg><span class="text">Edit</span>
        </a>`;
}

/**
 * Display an available or assigned meal train date, with action buttons
 * Expects trainDate to be a nAccessibleEntity<nMealTrainDate>
 */
export class MealDateRow extends UnshadowedElement {
    static elementName() { return "meal-date-row" }

    static properties = {
        trainDate: { type: Object },
    };

    render() {
        let rowContent = "";
        let actionContent = "";

        // May have an AssignedUser object with everything set to null, so check Id
        if (this.trainDate.Entity.AssignedUser && this.trainDate.Entity.AssignedUser.Id) {
            // Note: for non-meals (Plus) there is no description, so the notes get promoted to the description area
            rowContent = html`
                <div class="calendar-list-row__content-inner">
                    <div class="calendar-list-row__header-row">
                        <user-avatar avatar=${this.trainDate.Entity.AssignedUser.Avatar} initials=${this.trainDate.Entity.AssignedUser.Initials}></user-avatar>
                        <div>
                            <p class="calendar-list-row__name">${this.trainDate.Entity.AssignedUser.FullName}</p>
                            <p class="calendar-list-row__description">
                                ${this.trainDate.Entity.CategoryName === "Meal" ? html`<text-revealer cutoff="80" text="${this.trainDate.Entity.Description}"></text-revealer>` : html`<text-revealer cutoff="80" text="${this.trainDate.Entity.Notes}"></text-revealer>`}
                            </p>
                        </div>
                    </div>
                    ${(this.trainDate.Entity.CategoryName === "Meal" && this.trainDate.Entity.Notes) ? html`<p class="calendar-list-row__notes"><text-revealer cutoff="120" text="${this.trainDate.Entity.Notes}"></text-revealer></p>` : null}
                </div>
            `;
            actionContent = GetActionButtons(this.trainDate.Entity);
        } else {
            if (IsDateInPast(this.trainDate.Entity.Date)) {
                // Unclaimed past dates
                rowContent = html`This date has passed`;
            } else {
                // Unclaimed future dates
                rowContent = html`${!window.CurrentTrain.IsPlus ? html`<p class="font:label-s">Available</p>` : null}`;
                actionContent = html`<a class="button button-rectangle button-teal volunteer-button" href="/trains/${window.CurrentTrain.Id}/volunteer/${this.trainDate.Entity.Id}">Volunteer</a>`;
            }
        }

        return html`
            <div class="calendar-list-row"
                ?data-is-past=${IsDateInPast(this.trainDate.Entity.Date)}
                ?data-is-booked=${this.trainDate.Entity.AssignedUser && this.trainDate.Entity.AssignedUser.Id}
                ?data-can-edit-booking=${(this.trainDate.CanAdminister && !IsDateInPast(this.trainDate.Entity.Date)) || window.CurrentTrain.IsAdmin}
                ?data-is-own-booking=${this.trainDate.Entity.AssignedUser && this.trainDate.Entity.AssignedUser.Id === window.UserHash}>
                <div class="calendar-list-row__date">
                    <h3><span>${IsoDateFormatter.ShortMonth(this.trainDate.Entity.Date)}&nbsp;${IsoDateFormatter.ShortestDay(this.trainDate.Entity.Date)}</span>
                    <span>${IsoDateFormatter.ShortWeekday(this.trainDate.Entity.Date)}</span></h3>
                </div>
                <div class="calendar-list-row__content-wrapper">
                    <div class="calendar-list-row__content">
                        ${window.CurrentTrain.IsPlus ? html`
                            <div class="calendar-list__plus-item">
                                <span>${this.trainDate.Entity.CategoryName}:</span>
                                <text-revealer cutoff="120" text="${this.trainDate.Entity.Title}"></text-revealer>
                            </div>` : null}
                        ${rowContent}
                    </div>
                    <div class="calendar-list-row__actions">
                        ${actionContent}
                    </div>
                </div>
            </div>
        `;
    }
}
